module.exports = __webpack_public_path__ + "static/Sdk-1c781a87d3d0b3c16d6130a8675526d6.svg";